<template>

    <v-content>
        <v-container fluid>

            <panelcontainer>
                <div class="headline" slot="headline">Satış / {{this.order_type.toUpperCase()}}</div>
                <div slot="actions">
					<actions v-if="getAuth.isAdmin" module="orders" :item="item" />
                    <v-btn tile color="indigo" dark @click="saveItem()">
                        <v-icon>{{mdiContentSave}}</v-icon> Kaydet
                    </v-btn>
                </div>
                <loading v-if="isLoading" text="Sipariş bilgileri yükleniyor..." size="80" width="2" />

                <template v-if="!isLoading">
                    <v-container grid-list-md>
                        <v-layout wrap v-if="getAuth.isAdmin">
                            <v-flex xs12 mb-3 mt-3>
                                <v-text-field label="Başlık" v-model="item.title" outlined hide-details placeholder="Örn: Lanxess Germany"></v-text-field>
                            </v-flex>
                            <v-flex xs4 mb-3>
                                <v-select v-model="item.user_id" :items="users" item-text="fullname" item-value="id" label="Sipariş Sahibi" outlined></v-select>
                            </v-flex>
                            <v-flex xs4 mb-3>
                                <v-select v-model="item.status" :items="statusList" item-text="text" item-value="id" label="Sipariş Durumu" outlined></v-select>
                            </v-flex>
                            <v-flex xs4 mb-3>
                               <datepicker label="Teslimat Tarihi"  v-model="item.date_delivery_text" locale="tr-tr"/>
                            </v-flex> 
                        </v-layout>
                        <v-layout wrap v-if="getAuth.isUser">
                            <v-flex xs12 md8 mb-3 mt-3>
                                <v-text-field label="Başlık" v-model="item.title" outlined hide-details placeholder="Örn: Lanxess Germany"></v-text-field>
                            </v-flex>
                            <v-flex xs4 mb-3 mt-3>
                               <datepicker label="Teslimat Tarihi"  v-model="item.date_delivery_text" locale="tr-tr"/>
                            </v-flex> 
                        </v-layout>
                    </v-container>
					<table class="table table-striped table-borderless table-hover">
                        <thead>
                            <tr>
                                <th style="width:1%;">No</th>
                                <th>Ürün</th>
                                <th style="width:1%;">Adet</th> 
                                <th style="width:1%;" v-if="getAuth.isAdmin">Teslim</th>
                                <th style="width:1%;" class="actions"></th>
                                <th style="width:1%;" class="actions"></th>
                            </tr>
                        </thead>
                        <tbody class="no-border-x">
                            <tr v-for="(entry, entryIndex) in item.entries" :key="entryIndex" >
								<td>{{entryIndex+1}}</td>
                                <td class="cell-detail" v-if="getAuth.isAdmin || (getAuth.isUser && item.status == 0)">
                                    <v-autocomplete v-model="entry.product_id" :items="products" item-value="id" item-text="fullname" :label="_empty_label" outlined hide-details="" dense></v-autocomplete>
                                </td>
								<!-- ürün kaydedilince -->
                                <td class="cell-detail" v-else>
                                    <span><b>Tanigan AN </b></span>
                                    <span class="cell-detail-description">Lanxess Germany</span>
                                </td>
                                <td> 
									<inputcounter v-model="entry.count"/>
								</td>
                                <td v-if="getAuth.isAdmin">
									<inputcounter v-model="entry.done" :min="0" :max="entry.count"/>
								</td>
                                <td class="actions">
                                    <v-btn small icon color="primary" dark @click="addEntry(entryIndex)">
                                        <v-icon>{{mdiTableRowPlusBefore}}</v-icon>
                                    </v-btn>
                                </td>
                                <td class="actions">
                                    <v-btn small icon color="red" dark @click="removeEntry(entryIndex)">
                                        <v-icon>{{mdiCloseCircle}}</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </table> 
					<div class="text-center mb-4">
						<v-btn tile color="green" dark @click="addEntry()">
							<v-icon>{{mdiPlus}}</v-icon> Yeni Satır Ekle
						</v-btn>
					</div>
                </template>
            </panelcontainer>

            <v-layout row>






            </v-layout>
        </v-container>
    </v-content>


</template>


<script>
    import loading from "@/components/utils/loading"
    import panelcontainer from "@/components/utils/panelcontainer"
    import inputcounter from "@/components/inputs/counter"
    import datepicker from "@/components/inputs/datepicker" 
    import actions from "@/components/utils/actions"
    import {
        mdiPlus,
        mdiCloseCircle,
        mdiBellCheck,
        mdiTimerSand,
        mdiEmailSend,
        mdiCalendarRange,
        mdiTableRowPlusBefore,
        mdiContentSave,
    } from '@mdi/js';
    export default {
        components: {
            loading,
            panelcontainer,
            inputcounter,
            datepicker,
            actions,
        },
        data: () => ({
            mdiPlus: mdiPlus,
            mdiCloseCircle: mdiCloseCircle,
            mdiBellCheck: mdiBellCheck,
            mdiTimerSand: mdiTimerSand,
            mdiEmailSend: mdiEmailSend,
            mdiCalendarRange: mdiCalendarRange,
            mdiTableRowPlusBefore: mdiTableRowPlusBefore,
            mdiContentSave: mdiContentSave,

			order_type : "",

            isLoading: false,
            dialogEditor: false,
            dialogRemove: false,
            statusList: [], 
            products: [], 
            users: [], 
			item: {},
			
			actionDialogShow : false,
			actionDialogText : "",
			actionDialogColor : "",
			_empty_label : ""
        }),
		mounted(){
			this.order_type = this.$route.params.order_type;
			this.item_id = this.$route.query.id || ""
			this.loadUsers() 
			this.loadProducts() 
			this.loadStatusList() 
			this.loadItem() 
		},
        methods: {
			loadUsers(){
				this.$http.get( process.env.VUE_APP_API_URL + "/users/shared", {
					params : { }
				}).then(response => {
					this.users = response.body;  
				}) 
			},
			loadProducts(){
				this.$http.get( process.env.VUE_APP_API_URL + "/products/legit", {
					params : { }
				}).then(response => {
					this.products = response.body;  
				}) 
			},
			loadStatusList(){
				this.$http.get( process.env.VUE_APP_API_URL + "/orders/statusList", {
					params : { }
				}).then(response => {
					this.statusList = response.body;  
				}) 
			},
			loadItem(){
				this.isLoading = true;
				if(this.item_id == ""){
					this.setNewItemData();
					this.isLoading = false; 
				}else{ 
					this.$http.get( process.env.VUE_APP_API_URL + "/orders/info", {
						params : { id : this.item_id, order_type : this.order_type }
					}).then(response => {
						this.item = response.body; 
						this.isLoading = false; 
					})  
				}
			},
			setNewItemData(){
				this.item = {
					id:"",
					title : "",
					user_id : 0,
					status : 0,
					date_delivery_text : "", 
					entries : [], 
				} 
			},
			addEntry(before){
				var entry = {
					product_id : 0,
					count : 0,
					done : 0 
				}
				if(before === 0 || before > 0){
					this.item.entries.splice(before, 0, entry);
				}
				else{
					this.item.entries.push(entry)
				}
			},
			removeEntry(i){
				this.item.entries.splice(i, 1);
			},  
            saveItem() {
				this.isLoading = true; 
				this.item.order_type = this.order_type
				this.$http.post( process.env.VUE_APP_API_URL + "/orders/save", this.item).then(response => {  
					if(response.body.success){
						this.actionDialogShow = true;
						this.actionDialogText = "Kayıt başarılı"
						this.actionDialogColor = "green"
						this.$router.replace("/orders/"+this.order_type+"/edit/?id="+response.body.id)
						setTimeout(()=>{
							location.reload();
						},500)
					}
					else{
						this.actionDialogShow = true;
						this.actionDialogText = response.body.reason
						this.actionDialogColor = "red" 
						this.isLoading = false;
					} 
				}) 
            }, 
        },
		computed:{
			getAuth(){
				return this.$store.getters.getAuth;
			}
		}
    }
</script>

<style>

</style>